export type Stage =
  | 'visitors'
  | 'signups'
  | 'projects'
  | 'checkoutLink'
  | 'checkoutConverted'
  | 'proConverted'

export const STAGE_ORDER: Stage[] = [
  'visitors',
  'signups',
  'projects',
  'checkoutLink',
  'checkoutConverted',
  'proConverted',
]

export const STAGE_LABELS: Record<Stage, string> = {
  visitors: 'Visitors',
  signups: 'Signed up',
  projects: 'Created project',
  checkoutLink: 'Got checkout link',
  checkoutConverted: 'Converted checkout link',
  proConverted: 'Converted to pro',
}

export const STAGE_SHORT: Record<Stage, string> = {
  visitors: 'Visitors',
  signups: 'Signups',
  projects: 'Projects',
  checkoutLink: 'Checkout link',
  checkoutConverted: 'Checkout started',
  proConverted: 'Pro',
}

export const STAGE_ACCENT: Record<Stage, string> = {
  visitors: '#6366f1',
  signups: '#8b5cf6',
  projects: '#06b6d4',
  checkoutLink: '#f59e0b',
  checkoutConverted: '#f97316',
  proConverted: '#10b981',
}

export const CHANNEL_COLORS: Record<string, string> = {
  paid_search: '#1A73E8',
  paid_social: '#E91E63',
  organic_search: '#34A853',
  organic_social: '#9C27B0',
  email: '#FB8C00',
  referral: '#00ACC1',
  direct: '#78909C',
}

export const CHANNEL_LABELS: Record<string, string> = {
  paid_search: 'Paid search',
  paid_social: 'Paid social',
  organic_search: 'Organic search',
  organic_social: 'Organic social',
  email: 'Email',
  referral: 'Referral',
  direct: 'Direct',
}

export function colorForChannel(ch: string): string {
  return CHANNEL_COLORS[ch] ?? '#94a3b8'
}

export function labelForChannel(ch: string): string {
  return CHANNEL_LABELS[ch] ?? ch
}

export function formatNumber(v: number): string {
  return new Intl.NumberFormat('en-US').format(Math.round(v))
}

export function formatCurrency(v: number, opts: { compact?: boolean } = {}): string {
  if (opts.compact && v >= 1000) return `$${(v / 1000).toFixed(2)}K`
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v)
}

export function formatDate(date: string): string {
  const [y, m, d] = date.split('-').map(Number)
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export function formatPct(v: number): string {
  if (!isFinite(v)) return '—'
  return `${v.toFixed(1)}%`
}

export const RANGES = [
  { label: '7d', days: 7 },
  { label: '14d', days: 14 },
  { label: '30d', days: 30 },
  { label: '90d', days: 90 },
] as const

export const ORGANIC_CHANNELS = [
  'paid_social',
  'organic_search',
  'organic_social',
  'email',
  'referral',
  'direct',
]

export const PAID_CHANNELS = ['paid_search']
